var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"403","title":_vm.title,"sub-title":_vm.subTitle}})
}
var staticRenderFns = []

export { render, staticRenderFns }